<template>
    <div class="container pt-5">
        <div class="row">
            <div class="col-4 col-sm-1 mt-5 mb-3"><div class="topic-separator w-100"></div></div>
            <div class="col-12 mb-3">
                <h2 class="color-black">2. Configure</h2>
            </div>
            <!-- <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 mb-sm-0">
                <div class="form-group text-left">
                    <RangeInput :max="20" :min="3" :step="1"
                                :startValue="8"
                                :storeCommitName="'SET_WORDS_LENGTH'"
                                :store-value-name="'wordsLength'"
                                :help="''"
                                :name="'wordLength'"
                                :title="'Desired words length'"/>
                </div>
            </div> -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 mb-sm-0">
                <div class="form-group text-left">
                    <RangeInput :max="10" :min="0" :step="1"
                                :startValue="1"
                                :store-commit-name="'SET_RANDOMNESS'"
                                :store-value-name="'randomness'"
                                :help="''"
                                :name="'randomness'"
                                :title="'Randomness'"/>
                </div>
            </div>
        </div>
        <!--<div class="row">
          <div class="col-12 my-3">
            <label v-on:click="toggleDictionary()" class="checkbox-container d-flex align-items-center">
              <span class="checkbox mr-2 d-inline-block" :class="{'checked': dictionaryMode}"></span>
              Only use dictionary words
            </label>
          </div>
        </div>-->
        <div class="row">
          <div class="col-12 my-3">
            <h3 class="mb-4">Filter extensions</h3>
            <label v-on:click="toggleDomainAvailability('com')" class="checkbox-container d-flex align-items-center">
              <span class="checkbox mr-2 d-inline-block" :class="{'checked': isDomainAvailabilityFilterActive('com')}"></span>
              Show only available .com domains
            </label>
            <label v-on:click="toggleDomainAvailability('co')" class="checkbox-container d-flex align-items-center">
              <span class="checkbox mr-2 d-inline-block" :class="{'checked': isDomainAvailabilityFilterActive('co')}"></span>
              Show only available .co domains
            </label>
            <label v-on:click="toggleDomainAvailability('io')" class="checkbox-container d-flex align-items-center">
              <span class="checkbox mr-2 d-inline-block" :class="{'checked': isDomainAvailabilityFilterActive('io')}"></span>
              Show only available .io domains
            </label>
          </div>
        </div>
    </div>
</template>

<script>
    import RangeInput from './RangeInput';
    import {TOGGLE_DICTIONARY_MODE, TOGGLE_DOMAIN_AVAILABILITY_FILTER} from '@/store/mutation-types';
    import {mapState} from 'vuex';

    export default {
        name: "GeneratorSettings",
        components: {
            RangeInput,
        },
        computed: {
            ...mapState([
              'dictionaryMode',
              'domainAvailabilityFilters'
            ])
        },
        methods: {
            toggleDictionary() {
              this.$store.commit(TOGGLE_DICTIONARY_MODE, {})
            },
            toggleDomainAvailability(extension) {
              this.$store.commit(TOGGLE_DOMAIN_AVAILABILITY_FILTER, {extension: extension})
            },
            isDomainAvailabilityFilterActive(extension) {
              return this.domainAvailabilityFilters.includes(extension);
            },
        }
    }
</script>

<style scoped lang="scss">
  .checkbox-container {
    cursor: pointer;
  }

  .checkbox {
      width: 1rem;
      height:1rem;
      border: 1px solid $black;
      border-radius: 4px;
      &.checked {
          background-color: $primary;
          border: 4px solid $black;
      }
  }
</style>
